import React from "react";
import { CellInfo } from "../QuestionMultiDropdownReduxSlice";
import styles from "./Cells.module.scss";
import { Cell } from "./Cell";

interface CellsProps {
  data: CellInfo[];
  onOptionSelected: (cellId: string, optionId: string) => void;
}

export function Cells(props: CellsProps) {
  const onOptionSelected = (cellId: string, optionId: string) => {
    props.onOptionSelected(cellId, optionId);
  };

  return (
    <div className={styles.CellsContainer}>
      {props.data.map((cell: CellInfo) => (
        <div>
          <Cell
            correctFeedback={cell.correctFeedback}
            incorrectFeedback={cell.incorrectFeedback}
            correct={cell.correct}
            answered={cell.answered}
            cellId={cell.id}
            imageURL={cell.imageUrl}
            altText={cell.altText}
            options={cell.options}
            selectedOption={cell.selectedOption}
            onOptionSelected={onOptionSelected}
          />
        </div>
      ))}
    </div>
  );
}
